var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nb-select',{attrs:{"options":_vm.items,"label":_vm.answerBlockData.label,"searchable":_vm.searchable,"optional":!_vm.answerBlockData.is_required},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})
}
var staticRenderFns = []

export { render, staticRenderFns }